import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "drinking_detection",
  localization: {
    en: {
      title: "Drinking detected",
      settingsHeader: "Drinking Detection",
    },
    fr: {
      title: "Buveur détecté",
      settingsHeader: "Détection de Boire",
    }
  },
  proto: {
    name: "EVENT_RAVEN_DRINKING_DETECTED",
    value: 140
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_CABIN,
  showBetaDecoration: false,
}
